import { IAPIConfigurationInfo } from "./Controller/RingStateController/RingStateController";

export interface IMetalGroup {
  name:string,
  material:'Yellow Gold'|'White Gold'|'Rose Gold'|'Platinum'|'Palladium'|'Sterling Silver'|'Titanium'|'Zirconium Grey'|'Zirconium Black'|'Tantalum'|'Cobalt Chrome',
  materialOptions?:('Yellow Gold'|'White Gold'|'Rose Gold'|'Platinum'|'Palladium'|'Sterling Silver'|'Titanium'|'Zirconium Grey'|'Zirconium Black'|'Tantalum'|'Cobalt Chrome')[],
  surface:'Polished'|'Brushed'|'Side Brushed'|'Hammered'|'Ice Matte'|'Diagonal Matte'|'Sand Matte',
  surfaceOptions?:('Polished'|'Brushed'|'Side Brushed'|'Hammered'|'Ice Matte'|'Diagonal Matte'|'Sand Matte')[],
  purity:'9ct'|'14ct'|'18ct'|'500'|'600'|'925'|'950',
  purityOptions?:('9ct'|'14ct'|'18ct'|'500'|'600'|'925'|'950')[],
  purityList?:any[]
}

export interface IStoneGroup {
  name:string,
  stone:'Natural Diamond'|'Lab Grown Diamond'|'Black Diamond'|'Sapphire'|'Ruby'
  stoneOptions:('Natural Diamond'|'Lab Grown Diamond'|'Black Diamond'|'Sapphire'|'Ruby')[]
}

export interface IMaterialGroup {
  name:string,
  zones:number[],
  materialOptions:string[],
  defaultMaterial:string,
  hideFromMenu:boolean,
  purityList?:IPurityGroup[]
}

export interface IPurityGroup{
  material:string;
  purity:string;
}

export const materialName = [
  'Yellow Gold','White Gold','Rose Gold','Platinum','Palladium','Sterling Silver','Titanium','Zirconium Grey','Zirconium Black','Tantalum','Cobalt Chrome'
]

export interface ISurfaceGroup {
  name:string,
  zones:number[],
  surfaceOptions:('Polished'|'Brushed'|'Side Brushed'|'Hammered'|'Ice Matte'|'Diagonal Matte'|'Sand Matte')[],
  defaultSurface:'Polished'|'Brushed'|'Side Brushed'|'Hammered'|'Ice Matte'|'Diagonal Matte'|'Sand Matte',
  hideFromMenu:boolean
}

export interface IBackendStoneGroup {
  name:string,
  zones:number[],
  typeOptions:('Natural Diamond'|'Lab Grown Diamond'|'Black Diamond'|'Sapphire'|'Ruby')[],
  defaultType:'Natural Diamond'|'Lab Grown Diamond'|'Black Diamond'|'Sapphire'|'Ruby',
  hideFromMenu:boolean
}

export interface IMinMaxThickness {
  width:number,
  min:number,
  max:number
}

export interface IIdealThickness {
  width:number,
  ideal:number
}

export interface IRotation {
  x:number
}

export interface ISizeExceptions {
  maxStoneSize:string[],
  maxStoneDepth:string[]
}

export interface IExceptionCondition {
  group:string,
  option:string[],
  wasChanged?:boolean
}

export interface IExceptionAction {
  type:'copy'|'prevent'|'message'|'debug'
}

export interface ICopyExceptionAction extends IExceptionAction {
  type:'copy',
  from:string,
  to:string[]
}

export interface IMessageExceptionAction extends IExceptionAction {
  type:'message',
  message:string
}

export interface IPreventExceptionAction extends IExceptionAction {
  type:'prevent',
  group:string[],
  option:('Yellow Gold'|'White Gold'|'Rose Gold'|'Platinum'|'Palladium'|'Sterling Silver'|'Titanium'|'Zirconium Grey'|'Zirconium Black'|'Tantalum'|'Cobalt Chrome')[]|('Polished'|'Brushed'|'Side Brushed'|'Hammered'|'Ice Matte'|'Diagonal Matte'|'Sand Matte')[]
}

export interface IException {
  conditions:IExceptionCondition[],
  actions:IExceptionAction[],
  type?:'material'|'surface'
}

export interface IRingData {
  SKU:string,
  stoneCount:number,
  shape?:string,
  relatedRings:{stoneCount:number, SKU:string}[],
  stoneCut:'Brilliant'|'Princess'|'Baguette',
  sizes:string[],
  widthOptions:number[],
  defaultWidth:number,
  thicknessOptions:number[],
  defaultThickness:number,
  stoneSizeOptions:number[],
  defaultStoneSize:number,
  minMaxThickness:IMinMaxThickness[],
  idealThickness:IIdealThickness[],
  rotation:IRotation,
  materialGroups:IMaterialGroup[],
  surfaceGroups:ISurfaceGroup[],
  stoneGroups:IBackendStoneGroup[],
  materialExceptions:IException[],
  surfaceExceptions:IException[],
  sizeExceptions:ISizeExceptions
}

export interface ISavedRingConfiguration {
  SKU:string,
  fingerSize:string,
  fingerSizeFormat:'auuk'|'usca'|'eu'|'ch'|'jpc',
  width:number,
  thickness:number,
  stoneSize:number,
  metalGroups:{
    name:string,
    material:'Yellow Gold'|'White Gold'|'Rose Gold'|'Platinum'|'Palladium'|'Sterling Silver'|'Titanium'|'Zirconium Grey'|'Zirconium Black'|'Tantalum'|'Cobalt Chrome',
    surface:'Polished'|'Brushed'|'Side Brushed'|'Hammered'|'Ice Matte'|'Diagonal Matte'|'Sand Matte',
    purity:'9ct'|'14ct'|'18ct'|'500'|'600'|'925'|'950'
  }[],
  stoneGroups:{
    name:string,
    stone:'Natural Diamond'|'Lab Grown Diamond'|'Black Diamond'|'Sapphire'|'Ruby'
  }[],
  engravingText:string,
  engravingFont:'Brush Script'|'Century Gothic'|'Snell Roundhand'|'Trajan'|'Dakota'
}

export interface IAppConfig {
  menuStyle:'ifr'|'luxe'|'simple'|'simpleLuxe',
  logoStyle:'ifr'|'luxe'|'simple',

  osURI:string,
  priceCheckURI:string,
  token:string,
  shopID?:string,
  userID?:string,
  email?:string,
  costPriceCheckURI:string,
  backendURI:string,
  assetURI:string,
  shortLinkTarget:string,
  legacy?:boolean,
  hideRef?:boolean,

  initialRingSKU?:string,
  savedRingConfiguration?:ISavedRingConfiguration|string,
  autoRotationDelay:number,
  autoRotationSpeed:number
  
  specialMode?:'material-image-capture'|'screenshot'|'video'|'capture',
  captureConfig?:string,

  noAutomaticRedirect?:boolean,
  additionalCheckoutData?:any,
  style?:any
};